module.exports = __webpack_public_path__ + "static/media/civic-watch-logo.a86f5fbb.png";